export default __webpack_public_path__ + "static/media/banner.42542e83.jpg";